import {Component} from 'react';
import {connect} from 'react-redux';

import {getChunks} from '../../../general/selectors';

import Animator from './Animator';
import Chunks from './Chunks';

class PreloadBar extends Component {

    constructor(props) {
        super(props);

        this.onLoad = this.onLoad.bind(this);

        this.state = this.constructor.getState(props);
    }

    static getState({chunks}) {
        const state = {chunks};

        chunks.forEach(({index}) => {
            state[index] = false;
        });

        return state;
    }

    render() {
        const {chunks, ...loaded} = this.state;

        return (
            <table className="preload-bar">
                <Animator loaded={loaded} />
                <tbody>
                    <Chunks
                        {...this.props}
                        chunks={chunks}
                        loaded={loaded}
                        onLoad={this.onLoad}
                    />
                </tbody>
            </table>
        );
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.chunks === prevState.chunks) return null;

        return PreloadBar.getState(nextProps);
    }

    onLoad(index, value) {
        this.setState({
            [index]: value,
        });
    }

}

const mapStateToProps = state => ({
    chunks: getChunks(state),
});

export default connect(mapStateToProps)(PreloadBar);
